import { render, staticRenderFns } from "./order-modal-context.vue?vue&type=template&id=b6cf6b36&scoped=true"
import script from "./order-modal-context.vue?vue&type=script&lang=js"
export * from "./order-modal-context.vue?vue&type=script&lang=js"
import style0 from "./order-modal-context.vue?vue&type=style&index=0&id=b6cf6b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cf6b36",
  null
  
)

export default component.exports